var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backtohome animated fadeInRight",on:{"click":function($event){return _vm.goBack()}}},[_c('Icon',{attrs:{"size":"30","type":"ios-arrow-back"}}),_vm._v(" BACK ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }